import React, { Component } from 'react';
import ReactLoading from 'react-loading';
import { toast } from 'react-toastify';
import swal from '@sweetalert/with-react';
import PropTypes from 'prop-types';
import EmployeeForm from './form';
import API from '../../services/api';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import moment from 'moment';

// Styles
import EmployeeList from './list';
import EmployeeContainer from '.';
import {
  Wrapper,
  Container,
  Content,
  SubContainer,
} from '../../css/styles/wrapper';
import EmployeeFilterForm from './employeeFilter';

class EmployeePage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      employee: null,
      employeeForm: false,
      employeeFilter: true,
      employees: [],
      employeeList: [],
      document: null,
      statusActive: true,
      statusInactive: false,
      loading: false,
      userUuidsWithPermission: {
        register_employees: [
          'e53ec43a-bef4-4bbc-b821-7bed7f3a6214', // Bruna
          'aaf0b0af-9ea5-4358-8d78-5d6b55b1fac1', // Cris
        ],
        delete_employee_files: [
          'e53ec43a-bef4-4bbc-b821-7bed7f3a6214', // Bruna
          'aaf0b0af-9ea5-4358-8d78-5d6b55b1fac1', // Cris
          '6129df05-79bb-4731-adfc-2b35942a9e98', // Denize
        ],
      },
      canRegisterEmployees: false,
      canDeleteFiles: false,
    };

    this.handleEdit = this.handleEdit.bind(this);

    this.getList();
  }

  componentDidMount() {
    const { userUuidsWithPermission } = this.state;
    const { useruuid } = this.props;

    const canRegisterEmployees = userUuidsWithPermission.register_employees.includes(useruuid);
    const canDeleteFiles = userUuidsWithPermission.delete_employee_files.includes(useruuid);

    this.setState({ canRegisterEmployees, canDeleteFiles });
    this.getList();
  }

  normalizeStatusFilter = (statusActive, statusInactive) => {
    if (!statusActive && !statusInactive) {
      return {
        statusActive: true,
        statusInactive: false,
      };
    }

    return {
      statusActive,
      statusInactive,
    };
  };

  filterEmployeesByStatus = (employees, statusActive, statusInactive) => {
    const normalizedStatus = this.normalizeStatusFilter(
      statusActive,
      statusInactive
    );

    return (employees || []).filter(item => {
      const isInactive = !!item?.deletedAt;

      return (
        (normalizedStatus.statusActive && !isInactive) ||
        (normalizedStatus.statusInactive && isInactive)
      );
    });
  };

  getList = async value => {
    this.setState({ loading: true });
    // const { onEmployeesList } = this.props;

    try {
      const response = await API.get('/employees');
      const { statusActive, statusInactive } = this.state;
      const filteredEmployees = this.filterEmployeesByStatus(
        response.data,
        statusActive,
        statusInactive
      );

      this.setState({
        employeeList: filteredEmployees,
        employees: response.data,
        loading: false,
      });

      // onEmployeesList(response.data, value);
    } catch (err) {
      toast.error('Um erro aconteceu durante o carregamento!');
      this.setState({ loading: false });
    }
  };

  handleCreation = async value => {
    const { onEmployeeSubmit } = this.props;

    const data = {
      name: value.name.toUpperCase(),
      telephone: value.telephone || null,
      cnh: value.cnh || null,
      address: value.address || null,
      nickname: value.nickname || null,
      document: value.document || null,
      account: value.account || null,
      account_verifying_digit: value.account_verifying_digit || null,
      branch: value.branch || null,
      bank: value.bank || null,
      key: value.key || null,
    };

    try {
      const response = await API.post('employees', { ...data });

      this.getList(response.data);
      this.handleNew();
      toast.success('Funcionário criado com sucesso!');
      // onEmployeeSubmit();
    } catch (err) {
      toast.error('Um erro aconteceu durante o cadastro!');
    }
  };

  getEmployeeList = async values => {
    let statusFilter = {
      statusActive: this.state.statusActive,
      statusInactive: this.state.statusInactive,
    };

    let localEmployee = this.state.employee;
    let localDocument = this.state.document;
    let localTelephone = this.state.telephone;
    let localCnh = this.state.cnh;

    if (values) {
      statusFilter = this.normalizeStatusFilter(
        values.statusActive,
        values.statusInactive
      );

      localEmployee = values.employee || null;
      localDocument = values.document || null;
      localTelephone = values.telephone || null;
      localCnh = values.cnh || null;
    }

    try {
      const response = await API.get(
        `employees/${localEmployee?.uuid || null}/${localDocument || null}/${localTelephone ||
          null}/${localCnh || null}`
      );

      const filteredEmployees = this.filterEmployeesByStatus(
        response?.data,
        statusFilter.statusActive,
        statusFilter.statusInactive
      );

      this.setState({
        employee: localEmployee,
        document: localDocument,
        telephone: localTelephone,
        cnh: localCnh,
        statusActive: statusFilter.statusActive,
        statusInactive: statusFilter.statusInactive,
        employeeList: filteredEmployees || null,
        loading: false,
      });
    } catch (err) {
      toast.error('Um erro aconteceu durante o carregamento!');
      this.setState({ loading: false });
    }
  };

  handleEdit = object => {
    const { employeeForm, employeeFilter } = this.state;
    console.log(
      object,
      '<<<<<---------------------------------------------ooaojsadioasd---'
    );
    this.setState({
      employee: object,
      employeeForm: !employeeForm,
      employeeFilter: !employeeFilter,
    });
  };

  handleEmployeeFormState() {
    const { employeeForm, employeeFilter } = this.state;

    this.setState({
      employeeForm: !employeeForm,
      employeeFilter: !employeeFilter,
    });
  }

  handleEmployeesList = (employees, employee) => {
    this.setState({
      employees,
      employeeList: employees,
      employee: employee,
    });
  };

  handleNew = () => {
    this.setState({
      employee: null,
      employeeForm: false,
      employeeFilter: true,
    });
  };

  handleUpdate = async value => {
    // const { onEmployeeSubmit } = this.props;
    const { employee } = this.state;
    const deletedAt = value.deletedAt
      ? moment(value.deletedAt, 'YYYY-MM-DD').toISOString()
      : null;

    const data = {
      name: value.name.toUpperCase(),
      telephone: value.telephone || null,
      cnh: value.cnh || null,
      address: value.address || null,
      nickname: value.nickname || null,
      document: value.document || null,
      account: value.account || null,
      account_verifying_digit: value.account_verifying_digit || null,
      branch: value.branch || null,
      bank: value.bank || null,
      key: value.key || null,
      deletedAt,
    };

    try {
      await API.put(`/employees/${employee.uuid}`, { ...data });

      this.getList();
      this.handleNew();
      toast.success('Funcionário atualizada com sucesso.');
      // onEmployeeSubmit();
    } catch (err) {
      toast.error('Um erro aconteceu durante a atualização!');
    }
  };

  handleDelete = async uuid => {
    try {
      const confirmDelete = await swal({
        dangerMode: true,
        text: 'Confirma a exclusão do funcionário?',
        buttons: {
          cancel: 'Não',
          confirm: 'Sim',
        },
      });

      if (confirmDelete) {
        await API.put(`employees/${uuid}`, {
          deletedAt: moment().toISOString(),
        });

        this.getList();

        toast.success('Funcionário deletado com sucesso!');
      }
    } catch (err) {
      toast.error(
        'Não é possível excluir funcionários relacionados a serviços ou manutenções!'
      );
    }
  };

  exportToCSV = (csvData, fileName) => {
    const fileType =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';

    const fileExtension = '.xlsx';

    const ws = XLSX.utils.json_to_sheet(csvData);

    ws['!cols'] = [
      { wch: 50 },
      { wch: 50 },
      { wch: 30 },
    ];


    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };

    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

    const data = new Blob([excelBuffer], { type: fileType });

    FileSaver.saveAs(data, fileName + fileExtension);
  };

  generateExcelData = async () => {
    try {
      const { employees } = this.state;

      const response = await API.get('/employeefiles/period-due-date');

      const employeeUuids = new Set(
        (employees || [])
          .filter(item => !item?.deletedAt)
          .map(item => item?.uuid)
          .filter(Boolean)
      );

      const filteredResponse = (response.data || []).filter(item => {
        const employeeUuid =
          item?.employee?.uuid ||
          item?.employeeUuid ||
          item?.employee_uuid;

        return employeeUuids.has(employeeUuid);
      });

      const data = filteredResponse.map(item => ({
        'FUNCIONARIO': item?.employee?.name || '',
        'ARQUIVO': item?.file?.name || '',
        'VENCIMENTO': item.dueDate
          ? new Intl.DateTimeFormat('pt-BR', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
              timeZone: 'America/Sao_Paulo',
            }).format(new Date(item.dueDate))
          : '',
      }));

      this.exportToCSV(data, 'funcionarios-com-vencimento');
    } catch (err) {
      toast.error('Um erro aconteceu durante a exportação!');
    }
  }


  render() {
    const {
      employee,
      employees,
      employeeForm,
      employeeFilter,
      employeeList,
      document,
      telephone,
      cnh,
      statusActive,
      statusInactive,
      loading,
      canRegisterEmployees,
      canDeleteFiles,
    } = this.state;
    // const {employee} = this.props

    return (
      <Wrapper>
        <Container>
          <header>
            <h1>FUNCIONÁRIOS</h1>
            <div className="buttons-container">
              <button
                type="button"
                onClick={this.generateExcelData}
              >
                EXCEL ARQUIVOS COM VENCIMENTO ATÉ 90 DIAS
              </button>
              {canRegisterEmployees && !employeeForm && (
                <button
                  type="button"
                  onClick={() => this.handleEmployeeFormState()}
                >
                  NOVO FUNCIONÁRIO
                </button>
                
              )}
              {employeeForm && (
                <button
                    type="button"
                    onClick={() => this.handleEmployeeFormState()}
                  >
                    LISTA
                  </button>
                )              
              }
            </div>
          </header>
          <Content>
            <SubContainer visible>
              <SubContainer visible={employeeFilter}>
                <div ref={this.refEmployees} />
                {loading ? (
                  <ReactLoading
                    type="spin"
                    color="#011826"
                    height={40}
                    width={40}
                  />
                ) : (
                  <EmployeeFilterForm
                    onList={this.getEmployeeList}
                    employees={employees}
                    employee={employee}
                    document={document}
                    telephone={telephone}
                    cnh={cnh}
                    statusActive={statusActive}
                    statusInactive={statusInactive}
                    employeeFilter={employeeFilter}
                    onEmployeeSubmit={() => this.handleEmployeeFormState()}
                  />
                )}
                <EmployeeList
                  employees={employees}
                  employeeList={employeeList}
                  onEdit={this.handleEdit}
                  onNew={this.handleNew}
                  onDelete={this.handleDelete}
                  team={this.props.team}
                  loading={loading}
                />
              </SubContainer>

              <SubContainer visible={employeeForm}>
                <EmployeeForm
                  employeeList={employeeList}
                  employee={employee}
                  employees={employees}
                  onCreation={this.handleCreation}
                  onEdit={this.handleEdit}
                  onUpdate={this.handleUpdate}
                  onNew={this.handleNew}
                  onDelete={this.handleDelete}
                  team={this.props.team}
                  employeeForm={employeeForm}
                  canDeleteFiles={canDeleteFiles}
                  canRegisterEmployees={canRegisterEmployees}
                />
              </SubContainer>
              {/* <EmployeeContainer
                employeeList={true}
                employeeForm={employeeForm}
                onEmployeesList={this.handleEmployeesList}
                onEmployeeSubmit={() => this.handleEmployeeFormState()}
                employee={employee}
                employees={employees}
              /> */}
            </SubContainer>
          </Content>
        </Container>
      </Wrapper>
    );
  }
}

EmployeePage.propTypes = {
  employeeForm: PropTypes.bool,
  onEmployeeSubmit: PropTypes.func,
  onEmployeesList: PropTypes.func,
  team: PropTypes.object,
};

export default EmployeePage;